import { z } from 'zod'

import { ChannelType } from 'common/core/constants/ChannelType'
import { ReasonTypes, ReasonStatuses } from 'common/oneTimeNotify/constants/notifyReasonConstants'

export const NotificationReasonSchema = z.object({
  reason_id: z.number(),
  caption: z.string(),
  type: z.enum(ReasonTypes),
  channel: z.enum(ChannelType),
  description: z.string().nullable(),
  status: z.enum(ReasonStatuses),
  request_title: z.string().nullable(),
  // todo reuse types from uploader when they will be ready
  request_image: z.object({ caid: z.number(), img_big: z.string() }).nullable(),
  subscribers_count: z.number().optional(),
  rn_optin_link: z.string().nullish(),
  unique_usage_count: z.number().optional(),
})

export type NotificationReason = z.infer<typeof NotificationReasonSchema>
